<template>
  <IconLucideImage />
</template>
